module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-fr.0c8f0588.mp4";